module.exports = __webpack_public_path__ + "static/media/48315842_2309076032500908_2331309699967746048_o.1d5d1fa1.jpg";